import { FetchError, getFetchParams, getFetchResult } from "../helpers/helpers";
import { pacvueTokenAwareFetch } from "./pacvue-token-refresh/pacvueTokenAwareFetch";
/**
 * Asynchronously fetches data from a web API based on the provided request parameters.
 *
 * @template P - The type of the request parameters.
 * @template R - The type of the data to be fetched.
 * @template SHOW_HTTP_DATA - A boolean indicating whether to include HTTP response data in the total response.
 * @template TOTAL_RESPONSE - The type of the total response, including both the data and the optional HTTP response data.
 *
 * @param request - The request object defining the URL, parameters, cache options, and error handling.
 * @returns A promise that resolves to the total response object.
 * @throws {FetchError<R>} If an error occurs during the fetch operation.
 */
export const baseFetchWeb = async (request) => {
    try {
        const response = await pacvueTokenAwareFetch(request);
        const { result } = await getFetchResult(response, request);
        return result;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }
    catch (error) {
        if (request.showError) {
            window.setError?.({
                code: error.responseStatus ?? 0,
                message: error.message,
                ...(typeof request.showError !== "boolean" ? request.showError : {}),
            });
        }
        throw new FetchError(error.message, error.responseStatus ?? 0, error.result);
    }
};
// simple fetch w/o error handling
export const baseFetchWebSimple = async (request) => {
    const { url, body } = await getFetchParams(request);
    return await fetch(url, body);
};
